import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  useMaterialUIController,
  setLayout,
} from '../../../contexts/layoutContext';
import { MDBox } from '../../MDBox';

type DashboardLayoutProps = {
  children: React.ReactNode;
};

function DashboardLayout({ children }: DashboardLayoutProps) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, 'dashboard');
  }, [pathname]);

  return (
    <MDBox
      style={{ paddingBottom: '0px' }}
      // eslint-disable-next-line
      // @ts-ignore
      sx={{
        p: 3,
        position: 'relative',
        // Sidebar width (256, as the steerage app) plus the same 6px gap as before.
        marginLeft: miniSidenav ? `${104 / 16}rem` : `${262 / 16}rem`,
        // transition: transitions.create(['margin-left', 'margin-right'], {
        //   easing: transitions.easing.easeInOut,
        //   duration: transitions.duration.standard,
        // }),
      }}
    >
      {children}
    </MDBox>
  );
}

export { DashboardLayout };
